// src/pages/Onboard/StepEligibility.jsx
import React, { useState } from "react";
import axios from "axios";
import api from "../../utils/api";


// Client-side UK postcode helper (server still validates)
const looksLikeUKPostcode = (s) =>
  /^[A-Z]{1,2}\d[A-Z\d]?\s?\d[A-Z]{2}$/i.test(String(s).trim());

function Progress({ step, total }) {
  const pct = Math.round((step / total) * 100);
  return (
    <div style={{ marginBottom: 12 }}>
      <div style={{ height: 6, background: "#EDF2F7", borderRadius: 999 }}>
        <div
          style={{
            width: `${pct}%`,
            height: 6,
            background: "#10B981",
            borderRadius: 999,
            transition: "width .3s ease",
          }}
        />
      </div>
      <small className="muted">
        Step {step} of {total}
      </small>
    </div>
  );
}

export default function StepEligibility({
  totalSteps = 5,
  onEligible, // () => void
  onNotCovered, // optional: (payload) => void
  setAuthority, // lift state up
  setCovered, // lift state up
  setPostcode, // lift state up
}) {
  const [pc, setPc] = useState("");
  const [status, setStatus] = useState("idle"); // idle | checking | hit | miss | error
  const [label, setLabel] = useState("");
  const [authorityName, setAuthorityName] = useState("");
  const [msg, setMsg] = useState("");

  const check = async () => {
    setMsg("");
    setStatus("checking");
    try {
      const r = await api.get(`/public/eligibility/postcode`, {
        params: { pc },
      });
      const covered = !!r.data.covered;
      setCovered && setCovered(covered);
      setPostcode && setPostcode((r.data.postcode || pc).toUpperCase());
      setLabel(r.data.label || "");
      if (r.data.authority_name) {
        setAuthorityName(r.data.authority_name);
        setAuthority && setAuthority(r.data.authority_name);
      }
      setStatus(covered ? "hit" : "miss");
      if (!covered && onNotCovered)
        onNotCovered({ postcode: r.data.postcode || pc });
    } catch (e) {
      const err = e?.response?.data?.error;
      if (err === "invalid_postcode") {
        setMsg("Please enter a full UK postcode, e.g. SL1 2LT.");
      } else {
        setMsg("Couldn’t check right now. Please try again.");
      }
      setStatus("error");
    }
  };

  const continueNext = () => onEligible && onEligible();

  return (




    <div className="onboard-wrapper">
      <div className="onboard-card">
        <Progress step={1} total={totalSteps} />




        <h3>Check your area</h3>
        <p className="muted">
          Enter your postcode to see if we’re onboarding in your area.
        </p>
	

        <div className="row" style={{ marginBottom: 12 }}>
          <input
            value={pc}
            onChange={(e) => {
              setPc(e.target.value);
              setStatus("idle");
              setMsg("");
            }}
            placeholder="e.g., SL1 2LT"
            inputMode="text"
            autoCapitalize="characters"
          />
          <button
            className="btn"
            onClick={check}
            disabled={!looksLikeUKPostcode(pc) || status === "checking"}
          >
            {status === "checking" ? "Checking..." : "Check"}
          </button>


        </div>

<p style={{ marginTop: 16, textAlign: "center" }}>
  Already registered?{" "}
  <a href="/seller/login" style={{ color: "#2563EB", textDecoration: "underline" }}>
    Log in here
  </a>
</p>


 {/* Back to Home button */}
      <div style={{ marginBottom: "1rem", textAlign: "center" }}>
        <a
          href="/"
          className="btn"
          style={{
            background: "#F3F4F6", // light grey to contrast dark bg
            color: "#111827",
            textDecoration: "none",
            padding: "6px 14px",
            borderRadius: "6px",
            fontSize: "0.9rem",
            fontWeight: 500,
          }}
        >
          ← Back to Home
        </a>
      </div>


        {!looksLikeUKPostcode(pc) && pc.trim() && (
          <div
            className="toast"
            style={{ background: "#FFF8E1", color: "#7A4F01", marginBottom: 8 }}
          >
            Tip: enter a full postcode like <b>SL1 2LT</b>.
          </div>
        )}

{status === "hit" && (
  <div className="toast success" style={{ marginBottom: 16 }}>
    <strong>🎉 Congratulations!</strong>  
    <div style={{ fontSize: "1.2rem", marginTop: "0.5rem" }}>
      You’re eligible in your area{label ? ` (${label})` : ""}.
    </div>
    {authorityName && (
      <div style={{ marginTop: "0.3rem", fontSize: "1.1rem" }}>
        Local authority: <b>{authorityName}</b>
      </div>
    )}
  </div>
)}



        {status === "miss" && (
          <div
            className="toast"
            style={{ background: "#EEF2FF", color: "#3730A3", marginBottom: 12 }}
          >
            <b>You’re invited to set up!</b> We’re not publicly listing in your
            area yet, but you can create your account and get everything ready.
            We’ll notify you when listings open.
            {authorityName ? (
              <div>
                <small>Local authority: {authorityName}</small>
              </div>
            ) : null}
          </div>
        )}

        {msg && (
          <div className="toast error" style={{ marginBottom: 12 }}>
            {msg}
          </div>
        )}

        {(status === "hit" || status === "miss") && (
          <div className="actions">
            <button className="btn" onClick={continueNext}>
              {status === "hit"
                ? "Great — continue"
                : "Continue (set up your account)"}
            </button>
          </div>
        )}
      </div>
    </div>

  );
}

